import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable import/order */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { DOWNLOAD_FORMATS_TO_ICONS, DOWNLOAD_FORMATS_TO_LABELS, ALIGN_CONFIG } from './downloadFileMenu.constants';

// Styles
import styles from './downloadFileMenu.module.scss';

// Components
import Menu from '../Menu';
import DropDown from '../DropDown';
import IconAsBtn from '../../atoms/iconAsBtn';

// Helpers
import { createDownloadOptions, fireDownloadFileClickStreamEvent } from './downloadFileMenu.helpers';
var Item = Menu.Item;
var DownloadFileMenu = /*#__PURE__*/function (_PureComponent) {
  _inherits(DownloadFileMenu, _PureComponent);
  var _super = _createSuper(DownloadFileMenu);
  function DownloadFileMenu() {
    var _this;
    _classCallCheck(this, DownloadFileMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (params) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        module = _this$props.module;
      var key = _get(params, 'keyPath.0');
      var _key$split = key.split('.'),
        _key$split2 = _slicedToArray(_key$split, 2),
        downloadFormat = _key$split2[0],
        downloadType = _key$split2[1];
      fireDownloadFileClickStreamEvent({
        downloadFormat: downloadFormat,
        downloadType: downloadType,
        module: module
      });
      return onClick({
        downloadFormat: downloadFormat,
        downloadType: downloadType
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderDownloadLabel", function (downloadOption) {
      var downloadFormat = downloadOption.downloadFormat,
        _downloadOption$downl = downloadOption.downloadType,
        downloadType = _downloadOption$downl === void 0 ? EMPTY_OBJECT : _downloadOption$downl;
      var downloadTypeLabel = downloadType.name,
        downloadTypeIconSrc = downloadType.iconSrc;
      var iconSrc = downloadTypeIconSrc || DOWNLOAD_FORMATS_TO_ICONS[downloadFormat];
      var downloadFormatLabel = DOWNLOAD_FORMATS_TO_LABELS[downloadFormat];
      var label = downloadTypeLabel || downloadFormatLabel;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.dropdownItem
      }, /*#__PURE__*/React.createElement("img", {
        src: iconSrc,
        alt: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.downloadFormatLabel
      }, label));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDownloadOption", function (downloadOption) {
      var downloadFormat = downloadOption.downloadFormat,
        _downloadOption$downl2 = downloadOption.downloadType,
        downloadType = _downloadOption$downl2 === void 0 ? EMPTY_OBJECT : _downloadOption$downl2;
      var downloadTypeId = downloadType.id,
        _downloadType$disable = downloadType.disabled,
        disabled = _downloadType$disable === void 0 ? false : _downloadType$disable;
      var key = !_isEmpty(downloadType) ? "".concat(downloadFormat, ".").concat(downloadTypeId) : downloadFormat;
      return /*#__PURE__*/React.createElement(Item, {
        key: key,
        disabled: disabled
      }, _this.renderDownloadLabel(downloadOption));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDownloadMenu", function (downloadOptions) {
      var options = createDownloadOptions(downloadOptions);
      return /*#__PURE__*/React.createElement(Menu, {
        onClick: _this.handleClick,
        className: styles.menuContainer
      }, _map(options, _this.renderDownloadOption));
    });
    return _this;
  }
  _createClass(DownloadFileMenu, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        downloadOptions = _this$props2.downloadOptions,
        className = _this$props2.className,
        downloadIcon = _this$props2.downloadIcon;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement(DropDown, {
        align: ALIGN_CONFIG,
        overlay: this.renderDownloadMenu(downloadOptions)
      }, /*#__PURE__*/React.createElement(IconAsBtn, {
        className: styles.downloadIcon
      }, downloadIcon)));
    }
  }]);
  return DownloadFileMenu;
}(PureComponent);
DownloadFileMenu.propTypes = {
  downloadIcon: PropTypes.string,
  downloadOptions: PropTypes.arrayOf(PropTypes.shape({
    downloadFormat: PropTypes.string,
    downloadTypes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      iconSrc: PropTypes.string,
      disabled: PropTypes.bool
    }))
  })),
  onClick: PropTypes.func,
  className: PropTypes.string,
  module: PropTypes.string
};
DownloadFileMenu.defaultProps = {
  downloadIcon: 'icon-download1',
  downloadOptions: EMPTY_ARRAY,
  onClick: _noop,
  className: '',
  module: undefined
};
export default DownloadFileMenu;